<template>
    <div id="contendor-principal-sesiones" class="container-fluid p-0">
        <h1>Sesiones&nbsp;&nbsp;<i id="i-cambio-fecha" @click="accionModalCambioDeFecha({ mostrar: true })" class="fas fa-calendar-week" v-tooltip:right="'Filtrar por año'"></i></h1>
        <div id="contenedor-sesiones" class="row">
            <div v-for="(sesion,index) in listadoDeClinicasTMP" :key="'crs' + index" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pt-4 pr-2">
                <div id="sesion">
                    <div id="titulo-sesion">
                        <h5>{{ sesion.Nombre }}</h5>
                    </div>
                    <div id="informacion-sesion">
                        <div id="fecha-sesion">
                            <h6 style="cursor: pointer;"><i class="fas fa-calendar-week form-inline" v-tooltip:top="darFormatoAFechaDeSesionPenal({ fecha: sesion.FechaCompleta })"></i>{{ sesion.Fecha }}</h6>
                        </div>
                        <div id="sesion-descargas">
                             <h6 @click="descargarArchivoDeSesion({ rutaDeDescarga: sesion.OrdenDelDia })"><i class="fas fa-download"></i>Orden del dia.</h6>
                             <h6 @click="descargarArchivoDeSesion({ rutaDeDescarga: sesion.Ponencia })"><i class="fas fa-download"></i>Ponencia.</h6>
                             <h5>{{ sesion.Persona }}</h5>
                             <h6 @click="descargarArchivoDeSesion({ rutaDeDescarga: sesion.ActaDeLaSesion })"><i class="fas fa-download"></i>Acta de la sesión.</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL INFORMATIVO -->
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="modal-cambio-fecha">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">INGRESA EL AÑO</h4><i class="fas fa-calendar-week"></i>
                    </div>
                    <div class="modal-body pl-4 pr-4 pt-4 pb-0">
                        <!-- <div class="text-center">
                            <i class="far fa-check-circle"></i>
                            <h3>Enviado</h3>
                            <h6>El edicto ha sido enviado de manera exitosa</h6>
                            <button class="btn btn-primary">Ok</button>
                        </div> -->
                        <div class="form-group">
                            <select class="form-control" @change="cambioTiempo($event)">
                                <option value="-1">Selecciona un año</option>
                                <option v-for="(tiempo, index) in tiemposSesiones" :key="index" :value="tiempo.clave">{{ tiempo.texto }}</option>
                            </select>
                        </div>
                        <div id="acciones-modal" class="d-flex justify-content-end">
                            <h6 style="margin-right: 2em;" @click="accionModalCambioDeFecha({ mostrar: false })">Cancelar</h6>
                            <h6 @click="cambiarFechaDeClinicas">Buscar</h6>
                        </div>
                    </div>             
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from '@/../static/js/api'
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'

export default {
    props: {
        idContenedor: {
            type: Number,
            default: 0
        },
        sesiones: {
            type: Array,
            default: () => []
        },
        opciones: {
            type: Object,
            default: () => ({ 
            })
        },
    },
    directives: {
        tooltipF
    },
    data() {
        return {
            tiemposSesiones: [],
            tiempoSeleccionado: null,
            listadoDeClinicasTMP: []
        }
    },
    methods: {
        cambiarFechaDeClinicas: async function() { debugger
            let buscarPor = (this.campoRequeridoEsValido(this.tiempoSeleccionado)) ? this.tiempoSeleccionado : -1;
            await Promise.resolve(this.aplicarFiltradoDeClinicasPorTiempo({ tiempo: buscarPor }));
            this.accionModalCambioDeFecha({ mostrar: false });
        },
        cambioTiempo: function(evento) { 
            this.tiempoSeleccionado = parseInt(evento.target.value);
        },
        accionModalCambioDeFecha: function({ mostrar }) {
            const ACCION = (mostrar) ? 'show' : 'hide';
            $("#modal-cambio-fecha").modal(ACCION);
        },
        aplicarFiltradoDeClinicasPorTiempo: async function({ tiempo }) { debugger
            if(this.campoRequeridoEsValido(this.sesiones) && this.campoRequeridoEsValido(tiempo)) 
                this.listadoDeClinicasTMP = this.sesiones.filter(clinicaTemporal => moment(clinicaTemporal.FechaCompleta).format('YYYY') == tiempo);
            else
                this.listadoDeClinicasTMP = this.sesiones;
        },
        construirTiempoEnOpciones: async function() { 
            if(this.campoRequeridoEsValido(this.sesiones)) {
                this.tiemposSesiones = this.sesiones.map(clinica => {
                    let tiempoObj = {};
                    let tiempoDeClinica = moment(clinica.FechaCompleta).format('YYYY');
                    tiempoObj.clave = parseInt(tiempoDeClinica);
                    tiempoObj.texto = tiempoDeClinica;
                    return tiempoObj;
                });
                // se eliminan los años duplicados
                if(this.campoRequeridoEsValido(this.tiemposSesiones)) {
                    this.tiemposSesiones = this.tiemposSesiones.filter((tiempo, index, self) =>
                        index === self.findIndex((t) => (
                            t.clave === tiempo.clave
                        ))
                    );

                    // se ordena del menor al mayor
                    this.tiemposSesiones = this.tiemposSesiones.sort((a, b) => a - b );
                }
            }
        },
        descargarArchivoDeSesion: function({ rutaDeDescarga }) { 
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.href = `${api.conexion}${api.Comun.funcion.DescargarArchivo}?rutaDelArchivo=${ rutaDeDescarga }`
            a.click();
        },
        darFormatoAFechaDeSesionPenal: function({ fecha }) {
            let fechaConFormato = '';
            const MES = (moment(fecha).format('MMMM'));
            const DIA = moment(fecha).date();
            const TIEMPO = moment(fecha).format('YYYY');
            fechaConFormato = `${ DIA } de ${ MES } de ${ TIEMPO }`;
            return fechaConFormato;
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
    watch: {
        sesiones() {
            this.$nextTick(async () => {
                await Promise.resolve(this.construirTiempoEnOpciones());
                const TIEMPO_MAS_RECIENTE = (this.campoRequeridoEsValido(this.tiemposSesiones)) ? this.tiemposSesiones[0] : -1;
                await Promise.resolve(this.aplicarFiltradoDeClinicasPorTiempo({ tiempo: TIEMPO_MAS_RECIENTE.clave }));
            });
        }
    }
}
</script>
<style scoped>
#acciones-modal h6 {
    color: rgb(49, 49, 49) !important;
    font-weight: bold;
    cursor: pointer;
}

#acciones-modal h6:hover, #acciones-modal h6:focus {
    color: #be9a5e !important;
}

#acciones-modal {
    margin-top: 2em;
    padding-bottom: 1em;
}

#i-cambio-fecha {
    font-size: 3.5vmin;
    color: black;
    cursor: pointer;
}

#modal-cambio-fecha .modal-lg {
    max-width: 35% !important;
    z-index: 9999999999999999999999999999999999999;
}

#modal-cambio-fecha .modal-content {
    background-color: #FFFFFF;
    box-shadow: 0px 6px 20px 8px #424242;
}

#modal-cambio-fecha .modal-content .form-control{
    background-color: white;
    color: rgb(63, 62, 62);
    border: 1px solid #656161 !important;
    height: 2.5em;
}

#modal-cambio-fecha .modal-header {
    background-color: rgb(49, 49, 49);
    border: none;
    color: white;
    display: flex;
    align-items: center;
}

#contendor-principal-sesiones {
    padding-bottom: 12vmin !important;
}
#contendor-principal-sesiones h1 {
    padding-top: 6vmin;
}

#contendor-principal-sesiones h1 {
    color: #000000;
    font-weight: bold;
}

#sesion {
    border-radius: 6px;
    border: 1px solid black;
    background-color: white;
    color: black;
}

#titulo-sesion {
    background-color: black;
    color: white;
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    padding: 0.5em 1em 0.5em 1em;
}

#informacion-sesion {
    padding: 1em 1em 0.5em 1em;
}

#fecha-sesion h6 > i {
    font-size: 3vmin;
    margin-right: 1.5vmin;
}

#fecha-sesion h6 {
    font-size: 2.8vmin;
    font-weight: bold;
}

#sesion-descargas h6 > i {
    color: #be9a5e;
    margin-right: 0.5vmin;
    font-size: 2vmin;
}

#sesion-descargas h6 {
    color: #be9a5e;
    font-weight: bold;
    cursor: pointer;
    font-size: 1.8vmin;
}

#sesion-descargas h5 {
    font-size: 2vmin;
}
</style>


// WEBPACK FOOTER //
// src/components/Intranet/Formatos/CCardSesion.vue